<template>
  <v-server-table
    ref="magideiShiurTable"
    name="magideiShiurTable"
    class="magid-shiurim-table"
    v-if="magidShiur.id"
    :url="'/api/magidei-shiur/torah/' + magidShiur.id + '/shiurim'"
    :columns="columns"
    :options="options"
  >
    <div slot="beforeTable" class="py-3 d-md-none">
      <div class="col">
        <div class="d-flex flex-wrap w-100 d-md-none row align-items-center justify-content-center">
          <strong class="col-auto">{{ $_t('KW:filterBy') }}:</strong>
          <input class="form-control search-filter" v-model="filtername" :placeholder="$_t('KW:searchShiurim')" />
          <v-select class="select-filter w-100" v-model="filterParentTopics" placeholder="Filter By Topic" :options="magidShiur.parent_topics"></v-select>
          <v-select
            v-if="filterParentTopics"
            class="select-filter col-12"
            v-model="filterTopics"
            placeholder="Filter By SubTopic"
            :options="filteredTopics"
          ></v-select>
        </div>
        <div class="d-flex flex-wrap w-100 d-md-none align-items-center justify-content-center">
          <strong clas="col-auto">{{ $_t('KW:sortBy') }}:</strong>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('name')">
            {{ $_t('KW:name') }}
            <i class="fa" :class="setOrderClass('name')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('topic_id')">
            {{ $_t('KW:topic') }}
            <i class="fa" :class="setOrderClass('topic_id')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('recorded')">
            {{ $_t('KW:date') }}
            <i class="fa" :class="setOrderClass('recorded')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('length')">
            {{ $_t('KW:length') }}
            <i class="fa" :class="setOrderClass('length')"></i>
          </button>
        </div>
      </div>
    </div>
    <div slot="filter__name">
      <input class="form-control search-filter" v-model="filtername" :placeholder="$_t('KW:searchShiurim')" />
    </div>
    <div slot="mobile" slot-scope="props">
      <strong>
        <a :href="'/shiur/' + props.row.id">
          {{ props.row.name }}
        </a>
      </strong>
      {{ props.row.length }}
      <br />
      <topic-link :topic="topic(props.row.topic_id)"></topic-link>
      <br />
    </div>
    <div slot="filter__topic_id">
      <v-select class="select-filter col-12" v-model="filterParentTopics" :placeholder="$_t('KW:filterByTopic')" :options="magidShiur.parent_topics"></v-select>
      <v-select
        v-if="filterParentTopics"
        class="select-filter col-12"
        v-model="filterTopics"
        :placeholder="$_t('KW:filterBySubTopic')"
        :options="filteredTopics"
      ></v-select>
    </div>
    <div slot="name" slot-scope="props">
      <a :href="'/shiur/' + props.row.id">{{ props.row.name }}</a>
      <span
        v-b-tooltip.hover
        :title="isShiurimSaved(props.row) ? $_t('KW:removeSavedShiurim') : $_t('KW:saveShiurim')"
        role="button"
        class="bookmark-icon ml-4"
        @click="saveShiurEvent(props.row)"
      >
        <i class="fa" :class="isShiurimSaved(props.row) ? 'fa-bookmark' : 'fa-bookmark-o'"></i>
      </span>
    </div>
    <topic-link slot="topic_id" slot-scope="props" :topic="topic(props.row.topic_id)"></topic-link>
    <action-buttons slot="actions" :magid-shiur="magidShiur" :shiurim="props.row" type="torah" slot-scope="props"></action-buttons>
  </v-server-table>
</template>
<script>
import VueSelect from 'vue-select';
import { Event as VueTablesEvent } from 'vue-tables-2';
import ActionButtonsComponent from './../partials/ActionButtons.vue';
import TopicLinkComponent from './../magideiShiur/topicLink.vue';

export default {
  components: {
    vSelect: VueSelect,
    ActionButtons: ActionButtonsComponent,
    TopicLink: TopicLinkComponent,
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'magidShiurTable',
  },
  props: ['magidShiur'],
  data: function () {
    return {
      filterParentTopics: null,
      filterTopics: null,
      filtername: null,
      columns: ['mobile', 'name', 'topic_id', 'recorded', 'length', 'actions'],
      options: {
        headings: {
          mobile: '',
          topic_id: this.$_t('KW:topic'),
          name: this.$_t('KW:title'),
          recorded: this.$_t('KW:date'),
          length: this.$_t('KW:time'),
          actions: this.$_t('KW:playOrDownload'),
        },
        sortIcon: {
          base: 'fa fa-sort',
          up: 'fa-sort-amount-asc',
          down: 'fa-sort-amount-desc',
        },
        columnsDisplay: {
          mobile: 'max_tabletP',
          name: 'min_tabletL',
          topic_id: 'min_tabletL',
          length: 'min_tabletL',
          recorded: 'min_tabletL',
        },
        sortable: ['name', 'topic_id', 'recorded', 'length'],
        highlightMatches: true,
        filterByColumn: true,
        filterable: [],
        customFilters: ['name', 'topic_id'],
        perPage: 50,
        perPageValues: [25, 50, 100],
        initFilters: {
          topic_id: this.$route.query.parent_topic ? this.$route.query.parent_topic : 0,
        },
      },

      order: {
        column: null,
        isAscending: true,
      },
    };
  },
  watch: {
    //$route
    $route: function (newroute, oldroute) {
      VueTablesEvent.$emit('vue-tables.magideiShiurTable.filter::topic_id', newroute.query.parent_topic);
      this.filterParentTopics = this.parentTopic(newroute.query.parent_topic);
    },
    magidShiur: function () {
      this.filterParentTopics = this.parentTopic(this.$route.query.parent_topic);
    },
    filterParentTopics: function () {
      this.filterTopics = null;
      VueTablesEvent.$emit('vue-tables.magideiShiurTable.filter::topic_id', this.filterParentTopics ? this.filterParentTopics.value : '0');
    },
    filterTopics: function () {
      VueTablesEvent.$emit('vue-tables.magideiShiurTable.filter::topic_id', this.filterTopics ? this.filterTopics.value : '0');
    },
    filtername: function () {
      VueTablesEvent.$emit('vue-tables.magideiShiurTable.filter::name', this.filtername);
    },
  },

  computed: {
    filteredTopics: function () {
      if (this.filterParentTopics != null) {
        var self = this;
        var filtered = this.magidShiur.topics.filter(function (topic) {
          return topic.parent_id == self.filterParentTopics.value;
        });
        return filtered;
      }
      return [];
    },
  },
  methods: {
    slug: function (val) {
      if (val) {
        var result = val
          .toString()
          .toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^\w\-]+/g, '') // Remove all non-word chars
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, ''); // Trim - from end of text
        if (!result || 0 === result.length) {
          return 'hebrew';
        }
        return result;
      }
      return 'not-specified';
    },
    topic: function (id) {
      var filtered = this.magidShiur.topics.filter(function (topic) {
        return topic.value == id;
      });
      return filtered.length > 0 ? filtered[0] : null;
    },
    parentTopic: function (id) {
      var filtered = this.magidShiur.parent_topics.filter(function (topic) {
        return topic.value == id;
      });
      return filtered.length > 0 ? filtered[0] : null;
    },
    sortItems: function (column) {
      if (this.order.column !== column) {
        this.order.column = column;
        this.order.isAscending = true;
      } else {
        this.order.isAscending = !this.order.isAscending;
      }
      this.$refs.magideiShiurTable.setOrder(this.order.column, this.order.isAscending);
    },
    setOrderClass: function (name) {
      if (name == this.order.column) {
        return this.order.isAscending ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc';
      }
      return 'fa-sort';
    },
    saveShiurEvent(shiur) {
      if (!this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('auth/showModal');
        return;
      }
      if (this.isShiurimSaved(shiur)) {
        this.deleteShiurimForUser(shiur);
      } else {
        this.saveShiurimForUser(shiur);
      }
    },
    saveShiurimForUser(shiur) {
      this.$http.post('/api/user/save-shiur/' + shiur.id).then(response => {
        let savedShiurim = this.$store.state.profile.savedShiurim;
        savedShiurim.push(response.data);
        this.$store.dispatch('profile/loadSavedShiurim', savedShiurim);
      });
    },
    deleteShiurimForUser(shiur) {
      this.$http.post('/api/user/remove-shiur/' + shiur.id).then(response => {
        let savedShiurim = this.$store.state.profile.savedShiurim;
        savedShiurim = savedShiurim.filter(save => save.id !== shiur.id);
        this.$store.dispatch('profile/loadSavedShiurim', savedShiurim);
      });
    },
    isShiurimSaved: function (shiur) {
      if (this.$store.getters['auth/isLoggedIn']) {
        return this.$store.state.profile.savedShiurim.some(save => {
          return save.id === shiur.id;
        });
      }
      return false;
    },
  },
};
</script>
<style>
tr td:nth-child(3) {
  /* width: 120px; */
}
tr td:nth-child(4) {
  /* width: 90px; */
}
</style>